<template>
  <v-tooltip right
             open-on-click
             open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon
             v-bind="attrs"
             v-on="on">
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ tip }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    tip: {
      type: String,
      default: 'Set the tip',
    },
    icon: {
      type: String,
      default: 'fal fa-question',
    }
  }
}
</script>
